export default "__VITE_ASSET__a7c3b369__"